<template>
  <div class="container-table">
    <q-card-section>
      <q-table
        data-cy="plan-instrumeto-table"
        title="Informes de diagnóstico"
        :data="informesDiagnostico"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        :visible-columns="visibleColumns"
      >
        <template v-slot:body-cell-nombre="props">
          <q-td key="nombre" :props="props">
            {{ props.row.nombre }}
          </q-td>
        </template>
        <template v-slot:body-cell-fechaSubida="props">
          <q-td key="fechaSubida" :props="props">
            {{ props.row.fechaSubida }}
          </q-td>
        </template>
        <template v-slot:body-cell-obsevaciones="props">
          <q-td key="observaciones" :props="props">
            {{ props.row.observaciones }}
          </q-td>
        </template>

        <template v-slot:body-cell-informeAdjuntoNombre="props">
          <q-td key="informeAdjuntoNombre" :props="props">
            {{ props.row.informeAdjuntoNombre }}
          </q-td>
        </template>

        <template v-slot:body-cell-informeAdjuntoUrl="props">
          <q-td key="informeAdjuntoUrl" :props="props">
            <a v-if="props.row.informeAdjuntoUrl" :href="props.row.informeAdjuntoUrl" download target="_blank">
              <q-icon :name="'img:' + require('@/assets/img/file-download-black-24-dp.svg')"></q-icon>
            </a>
          </q-td>
        </template>

        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              data-cy="bDeleteCity"
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </q-card-section>
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar el informe? ${rowSelectedtoDelete.nombre}`
      "
      @save="deleteInforme()"
    />
  </div>
</template>
<script>
import { QTable, QTd, QCardSection } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import Message from '@/components/shared/mixins/Message.js';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';

export default {
  components: {
    QTable,
    QTd,
    QCardSection,
    DialogDelete
  },
  props: {
    isLoading: Boolean,
    informesDiagnostico: Array,
    title: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess',
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  mixins: [Loading, Message],
  data () {
    return {
      rowSelectedtoDelete: null,
      pagination: {
        rowsPerPage: 20
      },
      showDialogDelete: false,
      visibleColumns: ['nombre', 'fechaSubida', 'observaciones', 'informeAdjuntoNombre', 'informeAdjuntoUrl', 'eliminar'],
      columns: [
        {
          name: 'nombre',
          label: 'Nombre',
          align: 'left',
          field: 'nombre',
          sortable: true
        },
        {
          name: 'fechaSubida',
          label: 'Fecha de Subida',
          align: 'left',
          field: 'fechaSubida',
          sortable: true
        },
        {
          name: 'observaciones',
          label: 'Observaciones',
          align: 'left',
          field: 'observaciones',
          sortable: true
        },
        {
          name: 'informeAdjuntoNombre',
          label: 'Archivo adjunto',
          align: 'left',
          field: 'informeAdjuntoNombre',
          sortable: true
        },
        {
          name: 'informeAdjuntoUrl',
          label: '',
          align: 'left',
          field: 'informeAdjuntoUrl',
          sortable: true
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  created () {
    this.visibleColumns = this.isOnlyAccess || this.isCiudadano
      ? ['nombre', 'fechaSubida', 'observaciones', 'informeAdjuntoNombre', 'informeAdjuntoUrl']
      : ['nombre', 'fechaSubida', 'observaciones', 'informeAdjuntoNombre', 'informeAdjuntoUrl', 'eliminar'];
  },
  mounted () {
    this.$nextTick(() => {
      this.$eventHub.$on('saveNewInforme', newInforme => {
        if (this.informesDiagnostico.length + 1 <= 5) {
          this.informesDiagnostico.push(newInforme);
          // realizar guardado en base de datos
          this.saveInforme(newInforme);
        } else {
          this.showError('No se pueden añadir más de 5 informes');
        }
      });
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('saveNewInforme');
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    async deleteInforme () {
      this.showLoading();
      // obtenemos indice
      const index = this.informesDiagnostico.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.informesDiagnostico.splice(index, 1);
      this.showDialogDelete = false;
      // eliminamos en base de datos
      await this.$store.dispatch(types.ACTION_DELETE_INFORME_DIAGNOSTICO, { idInforme: this.rowSelectedtoDelete.id, idCiudad: this.ciudadSelected.id }).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },

    async saveInforme (newInforme) {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_DOCUMENTOPDF, { file: { Documento: newInforme.fileInformeAdjunto } }).then((response) => {
        this.saveInformeInMunicipio(response, newInforme);
      }).catch(() => {
        this.hideLoading();
      });
    },
    async saveInformeInMunicipio (idInforme, newInforme) {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_INFORME_DIAGNOSTICO, {
        idCiudad: this.ciudadSelected.id,
        idInforme: idInforme,
        datosInforme: { observaciones: newInforme.observaciones, nombre: newInforme.nombre } })
        .then((response) => {
          this.hideLoading();
          this.$emit('getInformesDiagnostico');
        }).catch(() => {
          this.hideLoading();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
}
</style>
